import { render, staticRenderFns } from "./NumberCard.vue?vue&type=template&id=9aeeec34&"
import script from "./NumberCard.vue?vue&type=script&lang=js&"
export * from "./NumberCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports